/** 
 * @description: 抹零设置
 * @author: fire
 */
<template>
    <div class="moling_set">
        <div class="moling-list" v-show="showList">
            <!--div class="row row-magin-bottom">
                <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_moling()">抹零设置</button>
            </div-->
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="moling_table_list"></table>
            </div>
        </div>
        <!-- 设置 -->
        <div class="moling-set" v-show="showSet">
            <div class="page-tit">抹零设置</div>
            <div class="row rowpadding">
                <label class="col-md-1 ctr-label-left">适用门店：</label>
                <div class="col-md-4">
                    <input class="form-control ctr-label-right" placeholder="请选择门店" v-model="moling_add_shop" ref="moling_add_shop" readonly="readonly" @click="moling_shop_fun($event)">
                    <span class="selection-clear" @click="clear_input('moling_add_shop')">×</span>
                    <span class="moling-arrow" role="presentation"><b role="presentation"></b></span>
                </div>
            </div>
            <div class="row rowpadding">
                <label class="col-md-1 ctr-label-left">抹零设置：</label>
                <div class="col-md-4">
                    <input class="form-control ctr-label-right" placeholder="请选择抹零设置" v-model="moling_add_set" ref="moling_add_set" readonly="readonly" @click="moling_set_fun($event)">
                    <span class="selection-clear" @click="clear_input('moling_add_set')">×</span>
                    <span class="moling-arrow" role="presentation"><b role="presentation"></b></span>
                </div>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="add_moling_save()">保存</button>
            </div>
        </div>
        <!-- 门店列表弹窗 -->
        <div class="ele-hide" ref="moling_shop">
            <div class="shop-seldiv">
                <ul class="shop-area">
                    <li>
                        <input type='checkbox' v-model='shop_sel_all' v-on:click='shopSelAll'>
                        <span>全选</span>
                    </li>
                    <li v-for="item in shop_checkboxdata">
                        <input type="checkbox" name="shop_area" v-model='shop_checkboxModel' :value="item.id">
                        <span>{{item.name}}</span>
                    </li>
                    <div style="clear:both;"></div>
                </ul>
            </div>
        </div>
        <!-- 抹零设置弹窗 -->
        <div class="ele-hide" ref="moling_alert_set">
            <div class="sel-seldiv">
                <ul class="set-area">
                    <!-- <li v-for="item in shop_checkboxdata">
                        <input type="checkbox" name="set_area" v-model='set_checkboxModel' :value="item.id">
                        <span>{{item.name}}</span>
                    </li> -->
                    <li>
                        <input id="set_checkboxModel1" type="radio" name="set_checkboxModel1" v-model='set_checkboxModel' value="无">
                        <label for="set_checkboxModel1">无</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel2" type="radio" name="set_checkboxModel2" v-model='set_checkboxModel' value="进位到“角”">
                        <label for="set_checkboxModel2">进位到“角”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel3" type="radio" name="set_checkboxModel3" v-model='set_checkboxModel' value="进位到“1元”">
                        <label for="set_checkboxModel3">进位到“1元”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel4" type="radio" name="set_checkboxModel4" v-model='set_checkboxModel' value="进位到“10元”">
                        <label for="set_checkboxModel4">进位到“10元”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel5" type="radio" name="set_checkboxModel5" v-model='set_checkboxModel' value="进位到“100元”">
                        <label for="set_checkboxModel5">进位到“100元”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel6" type="radio" name="set_checkboxModel6" v-model='set_checkboxModel' value="四舍五入到“角”">
                        <label for="set_checkboxModel6">四舍五入到“角”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel7" type="radio" name="set_checkboxModel7" v-model='set_checkboxModel' value="四舍五入到“1元”">
                        <label for="set_checkboxModel7">四舍五入到“1元”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel8" type="radio" name="set_checkboxModel8" v-model='set_checkboxModel' value="四舍五入到“10元”">
                        <label for="set_checkboxModel8">四舍五入到“10元”</label>
                    </li>
                    <li>
                        <input id="set_checkboxModel9" type="radio" name="set_checkboxModel9" v-model='set_checkboxModel' value="四舍五入到“100元”">
                        <label for="set_checkboxModel9">四舍五入到“100元”</label>
                    </li>
                    <div style="clear:both;"></div>
                </ul>
            </div>
        </div>
        <!-- 抹零修改 -->
        <div class="moling-modify" v-show="showModify">
            <div class="page-tit">抹零修改</div>
            <div class="row rowpadding">
                <label class="col-md-1 ctr-label-left">适用门店：</label>
                <div class="col-md-4">
                    <input class="form-control ctr-label-right" placeholder="请选择门店" v-model="moling_modify.name" ref="moling_modify_shop" readonly="readonly" ><!-- @click="moling_shop_fun($event)" -->
                    <span class="selection-clear" @click="clear_input('moling_modify_shop')">×</span>
                    <span class="moling-arrow" role="presentation"><b role="presentation"></b></span>
                </div>
            </div>
            <div class="row rowpadding">
                <label class="col-md-1 ctr-label-left">抹零设置：</label>
                <div class="col-md-4">
                    <input class="form-control ctr-label-right" placeholder="请选择抹零设置" v-model="moling_modify_set" ref="moling_modify_set" readonly="readonly" @click="moling_set_modify($event)">
                    <span class="selection-clear" @click="clear_input('moling_modify_set')">×</span>
                    <span class="moling-arrow" role="presentation"><b role="presentation"></b></span>
                </div>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="modify_moling_save()">保存</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
        export default {
        name: 'moling_set',
        data() {
            return {
                showList: true,
                showSet: false,
                moling_add_shop: "",
                moling_add_set: "",
                shop_sel_all: false,
                shop_checkboxdata: [],
                shop_checkboxModel:[],
                set_checkboxModel: "",

                showModify: false,  // 是否显示修改界面
                moling_modify: {},
                moling_modify_shop: "",    //
                moling_modify_set: "",  // 
            }
        },
        filters: {
        },
        components: {
        },
        mounted: function() {
            let _this = this;
            _this.$nextTick(function() {
                let _this = this;
                this.initTable();
            });
        },
        methods: {
            initTable: function() {
                let _this = this;
                $(_this.$refs.moling_table_list).bootstrapTable({
                    pageSize: 10,
                    ajax: function(params) {
                        _this.getMolingList(params);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [
                        {
                            field: "id",
                            title: "门店id",
                            visible: false
                        },
                        {
                            width: "33%",
                            field: "name",
                            title: "门店"
                        },
                        {
                            width: "33%",
                            field: "small_change_type_name",
                            title: "抹零设置"
                        },
                        {
                            title: "操作",
                            events: {
                                'click .modify': function(e, value, row) {
                                    _this.getSmallChangeSet(row.id);
                                }
                            },
                            formatter: function(value, row, index) {
                                return '<span class="text-blue modify">修改</span>'
                            }
                        }
                    ]
                });
            },
            // 获取抹零设置详情
            getSmallChangeSet: function (shopId) {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": shopId,    //  门店id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "setting/getSmallChangeSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.showModify = true;
                            _this.showList = false;
                            let result = data['response']["result"];
                            _this.moling_modify = result;

                            // let strSet_checkboxModel = "";
                            // if ( result["small_change_type"] == "1" ) {
                            //     strSet_checkboxModel = '无';
                            // } else {
                            //     strSet_checkboxModel = '进一位到“角”';
                            // }
                            _this.moling_modify_set = result.small_change_type_name;
                            _this.set_checkboxModel = result.small_change_type_name;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.close("出错啦");
                    }
                });
            },
            // 获取抹零列表
            getMolingList: function(params) {
                let _this = this;
                let pageNumber = 1;
                if (params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "setting/getSmallChangeList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            params.success({
                                total: data['response']['result']['total'],
                                rows: data['response']['result']['rows']
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.close("出错啦");
                    }
                });
            },
            // 点击‘抹零设置’
            add_moling: function() {
                this.showSet = true;
                this.showList = false;
                this.moling_add_shop = "";
                this.moling_add_set = "";
                this.shop_sel_all = "";
                this.shop_checkboxdata = [];
                this.shop_checkboxModel = [];
                this.set_checkboxModel = "";
            },
            // 选择门店
            moling_shop_fun: function(e) {
                let _this = this;
                _this.getshopdata();
                layer.confirm('', {
                    skin: 'add_moling_area',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['适用门店', true],
                    area: ['300px', ''], //宽高
                    content: $(_this.$refs.moling_shop),
                }, function() {
                    let texts = [];
                    _this.shop_checkboxdata.forEach(function(item) {
                        _this.shop_checkboxModel.forEach(function(item2) {
                            if(item.id == item2){
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.moling_add_shop = texts.join(",");
                    layer.closeAll();
                });
            },
            // 门店数据
            getshopdata: function() {
                var _this = this;
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_name":""
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true") {
                            _this.shop_checkboxdata = (data['response']['result']);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        
                    }
                });
            },
            //门店全选
            shopSelAll: function() {
                var _this = this;
                if(!this.shop_sel_all) {//实现全选
                    _this.shop_checkboxModel = [];
                    _this.shop_checkboxdata.forEach(function(item) {
                    _this.shop_checkboxModel.push(item.id);
                    });
                } else {//实现反选
                    this.shop_checkboxModel = [];
                }
            },
            // 选择抹零设置
            moling_set_fun: function(e) {
                let _this = this;
                layer.confirm('', {
                    skin: 'add_moling_area',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['抹零设置', true],
                    area: ['300px', ''], //宽高
                    content: $(_this.$refs.moling_alert_set),
                }, function() {
                    _this.moling_add_set = _this.set_checkboxModel;
                    layer.closeAll();
                });
            },
            // 选择抹零修改
            moling_set_modify: function(e) {
                let _this = this;
                layer.confirm('', {
                    skin: 'modify_moling_area',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['抹零设置', true],
                    area: ['300px', ''], //宽高
                    content: $(_this.$refs.moling_alert_set),
                }, function() {
                    _this.moling_modify_set = _this.set_checkboxModel;
                    layer.closeAll();
                });
            },
            // 返回
            backFun: function() {
                this.showList = true;
                this.showSet = false;
                this.showModify = false;
            },
            // 修改保存
            modify_moling_save: function() {
                let _this = this;
                let shop_id = "",
                    small_change_type = "";
            //     for(var i in _this.shop_checkboxModel ){
            //         shop_id.push(_this.shop_checkboxModel[i]);
            // 　　}
                shop_id = _this.moling_modify.id;
                if(_this.set_checkboxModel == '无') {
                    small_change_type = "1";
                } else if(_this.set_checkboxModel == '进位到“角”') {
                    small_change_type = "2";
                } else if(_this.set_checkboxModel == '进位到“1元”') {
                    small_change_type = "3";
                } else if(_this.set_checkboxModel == '进位到“10元”') {
                    small_change_type = "4";
                } else if(_this.set_checkboxModel == '进位到“100元”') {
                    small_change_type = "5";
                } else if(_this.set_checkboxModel == '四舍五入到“角”') {
                    small_change_type = "6";
                } else if(_this.set_checkboxModel == '四舍五入到“1元”') {
                    small_change_type = "7";
                } else if(_this.set_checkboxModel == '四舍五入到“10元”') {
                    small_change_type = "8";
                } else if(_this.set_checkboxModel == '四舍五入到“100元”') {
                    small_change_type = "9";
                }

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                            "small_change_type": small_change_type
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "setting/setSmallChange",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        layer.msg(data["response"]["error_msg"]);
                        _this.showList = true;
                        _this.showModify = false;
                        $(_this.$refs.moling_table_list).bootstrapTable("destroy");
                        _this.initTable();
                        // if(data['response']['result_code'] == "true") {
                        //     layer.msg(data["response"]["error_msg"]);
                        //     _this.showList = true;
                        //     _this.showModify = false;
                        //     $(_this.$refs.moling_table_list).bootstrapTable("destroy");
                        //     _this.initTable();
                        // } else {
                        //     Vue.timeoutfun(data.response.result_status, _this);
                        //     layer.msg(data["response"]["error_msg"]);
                        // }
                    },
                    error: function(err) {

                    }
                });
            },
            // 新增保存
            add_moling_save: function() {
                let _this = this;
                let shop_id = [],
                    small_change_type = "";
                for(var i in _this.shop_checkboxModel ){
                    shop_id.push(_this.shop_checkboxModel[i]);
            　　}
                if(_this.set_checkboxModel == '无') {
                    small_change_type = "1";
                } else if(_this.set_checkboxModel == '进位到“角”') {
                    small_change_type = "2";
                } else if(_this.set_checkboxModel == '进位到“1元”') {
                    small_change_type = "3";
                } else if(_this.set_checkboxModel == '进位到“10元”') {
                    small_change_type = "4";
                } else if(_this.set_checkboxModel == '进位到“100元”') {
                    small_change_type = "5";
                } else if(_this.set_checkboxModel == '四舍五入到“角”') {
                    small_change_type = "6";
                } else if(_this.set_checkboxModel == '四舍五入到“1元”') {
                    small_change_type = "7";
                } else if(_this.set_checkboxModel == '四舍五入到“10元”') {
                    small_change_type = "8";
                } else if(_this.set_checkboxModel == '四舍五入到“100元”') {
                    small_change_type = "9";
                }

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                            "small_change_type": small_change_type
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "setting/setSmallChange",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            _this.showList = true;
                            _this.showSet = false;
                            $(_this.$refs.moling_table_list).bootstrapTable("destroy");
                            _this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            }
        }
    }
</script>
<style lang="less">
    .moling_set {
        .row-magin-bottom {
            margin-bottom: 50px;
        }
        .rowpadding {
            margin: 0 0 36px;
        }
        .ctr-label-right {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-right: 40px;
        }
        .ctr-label-right[readonly] {
            background: #FFF;
            cursor: pointer;
        }
        .moling-arrow {
            position: absolute;
            right: 16px;
            top: 1px;
            width: 20px;
            height: 32px;
            cursor: pointer;
            b {
                position: absolute;
                left: 50%;
                top: 50%;
                width: 0;
                height: 0;
                margin: -2px 0 0 -4px;
                border-width: 5px 4px 0 4px;
                border-style: solid;
                border-color: #888 transparent transparent transparent;
            }
        }
        .shop-seldiv, .sel-seldiv {
            position: relative;
            display: block;
            width: 90%;
            padding: 30px 20px 20px;
            margin: 0 auto;
        }
        .shop-seldiv ul {
            padding: 0px 30px 20px 30px;
            border: 1px solid #e5e5e5;
            border-top: none;
        }
        .shop-seldiv li {
            overflow: hidden;
            float: left;
            width: 14.28%;
            height: 32px;
            line-height: 32px;
            color: #a29d9d;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .sel-seldiv li {
            height: 32px;
            line-height: 32px;
        }
        .shop-area {
            border:none !important;
        }
        .shop-area li {
            width:100% !important;
        }
    }
</style>